export const whatsappTemplates = {
    // Template base que todos os emails usarão
    
    baseTemplate: (content) => 
`*Sistema Avalioo - Avaliações Inteligentes*
${content}
`,
    
  
    alertDetrator: ({score, review, datahora, companyName, branchName ,contactName, contactPhone, contactWhatsapp, linkDiretoWhatsapp}) => ({
        content:   
`Avaliação da ${companyName}\n
*Unidade:* ${branchName}\n
*Data da Avaliação:* \n${datahora}\n
*Quem avaliou:* \n${contactName}\n
*Telefone de Contato:* \n${contactPhone}\n
*Link direto para o Whatsapp:* \n${linkDiretoWhatsapp}\n
*Nota:* \n${score}\n
*Detalhamento:* \n${review}

`
      }),

  
  };